import { useSelector } from "react-redux";
import { DataGrid } from "../../components";
import { getLocalized } from "../../redux/localization";
import { adminPackagesUrl } from "../../services/urls";
import createAdminPackages from "./create";
import AdminPackagesDetail from "./detail";

const AdminPackagesPage = () => {

    const localize = useSelector(getLocalized);

    const columns = [
        {
            dataField: "Name",
            caption: localize.getString("name")
        },
        {
            dataField: "Currency",
            caption: localize.getString("currency")
        },
        {
            dataField: "LocationCount",
            caption: localize.getString("locationCount")
        },
        {
            dataField: "PeriodType",
            caption: localize.getString("periodtypename")
        },
        {
            dataField: "ProductCount",
            caption: localize.getString("productCount")
        },
        {
            dataField: "Price",
            caption: localize.getString("price")
        }
    ]


    return <DataGrid
        url={adminPackagesUrl}
        getByIdUrl={adminPackagesUrl}
        columns={columns}
        refObject={{}}
        title="Paketler"
        details={{
            width: "30%",
            height: "50%",
            getByIdUrl: adminPackagesUrl,
            title: localize.getString("packagesDetail"),
            component: AdminPackagesDetail,
        }}
        create={{
            component: createAdminPackages,
            width: "40%",
            height: "70%",
            createUrl: adminPackagesUrl,
            title: localize.getString("createPackage")

        }}
        remove={{
            url: adminPackagesUrl
        }}
        edit={{
            component: createAdminPackages,
            width: "40%",
            height: "70%",
            editUrl: adminPackagesUrl,
            title: localize.getString("editPackage")

        }}
    />


}

export default AdminPackagesPage;
